import { DoubleRightOutlined } from '@ant-design/icons';
import styles from '../card/index.module.scss';

export interface NavigationItem {
  pageName: string;
  description?: string;
  navigationPath?: string;
  path: string;
}

export interface NavigationData {
  resultType: 'MATCH' | 'CLARIFY' | 'FALLBACK';
  primary?: NavigationItem | null;
  alternatives?: NavigationItem[];
  message?: string | null;
  options?: string[];
}

interface NavigationPageCardProps {
  item: NavigationItem;
  primary?: boolean;
}

const NavigationPageCard = ({ item, primary }: NavigationPageCardProps) => (
  <div className={`${styles.navigationCard} ${primary ? styles.navigationCardPrimary : ''}`}>
    <strong className={styles.navigationPageName}>{item.pageName}</strong>
    {item.description && <span className={styles.navigationDescription}>{item.description}</span>}
    {primary && item.navigationPath && (
      <span className={styles.navigationPath}>
        <span>页面入口：</span>
        {item.navigationPath}
      </span>
    )}
    <a className={styles.navigationLink} href={item.path} target="_blank" rel="noopener noreferrer">
      <span>点击此处链接直接跳转</span>
      <DoubleRightOutlined />
    </a>
  </div>
);

export const renderNavigationAnswer = (
  data: NavigationData,
  index: number,
  onNavigationOptionClick?: (option: string) => void,
) => {
  if (data.resultType === 'CLARIFY') {
    return (
      <section key={index} className={styles.navigationClarify}>
        <div className={styles.navigationClarifyQuestion}>{data.message}</div>
        {/* <div className={styles.navigationClarifyQuestion}>请问您需要查看具体数据是：</div> */}
        <div className={styles.navigationOptions}>
          {(data.options || []).map((option, optionIndex) => (
            <button
              key={option}
              type="button"
              className={styles.navigationOption}
              onClick={() => onNavigationOptionClick?.(option)}
            >
              {optionIndex + 1}、{option}
            </button>
          ))}
        </div>
      </section>
    );
  }

  if (data.resultType === 'FALLBACK') {
    return <div key={index}>{data.message || '未找到匹配的功能页面'}</div>;
  }

  if (data.resultType !== 'MATCH' || !data.primary) return null;
  const alternatives = data.alternatives || [];
  return (
    <section key={index} className={styles.navigationResult}>
      <div className={styles.navigationHeading}>已为您定位</div>
      <NavigationPageCard item={data.primary} primary />
      {alternatives.length > 0 && (
        <>
          <div className={styles.navigationSubheading}>需求匹配较高的其他页面：</div>
          <div className={styles.navigationGrid}>
            {alternatives.map(item => (
              <NavigationPageCard key={item.path} item={item} />
            ))}
          </div>
        </>
      )}
    </section>
  );
};
